import { render, staticRenderFns } from "./Good2KnowItem.vue?vue&type=template&id=85d22a98&"
import script from "./Good2KnowItem.vue?vue&type=script&lang=js&"
export * from "./Good2KnowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Good2KnowItem.vue"
export default component.exports